import { createActionsHook } from 'react-sweet-state';

import {
  createDataHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { RiskReasonEntity } from '../../Risks/models/Risk';

const actionConfig = { resourcePath: '/risks/reasons' };

export const riskReasonsActions = createRestActions<RiskReasonEntity>(actionConfig);

export const RiskReasonsStore = createRestStore<RiskReasonEntity>({
  name: 'risk-reasons-store',
  actions: riskReasonsActions,
  actionConfig,
  containerDisplayName: 'risk-reasons-container',
  onInitAction: null,
});

export const useRiskReasonsData = createDataHook(RiskReasonsStore);
export const useRiskReasonsIsLoading = createLoadingHook(RiskReasonsStore);
export const useRiskReasonsActions = createActionsHook(RiskReasonsStore);
export const didRiskReasonsMutationFail = createMutationFailedCheck(actionConfig.resourcePath);